var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeweb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4547 1.60775C11.7508 -0.202586 8.87366 -0.202582 7.16982 1.60776L1.42291 7.71385C0.66951 8.51433 0.25 9.57216 0.25 10.6714V17.5666C0.25 19.8454 2.02182 21.7314 4.29614 21.8736L10.3191 22.25L16.3401 21.8737C18.6154 21.7315 20.3876 19.8439 20.3863 17.5642L20.3821 10.677C20.3815 9.5786 19.962 8.52181 19.2092 7.72197L13.4547 1.60775ZM10.1686 12.7091C10.2609 12.6524 10.3773 12.6524 10.4696 12.7091L12.7711 14.1223C12.8564 14.1746 12.9083 14.2674 12.9083 14.3674V17.3576C12.9083 17.8343 13.2947 18.2207 13.7714 18.2207C14.248 18.2207 14.6344 17.8343 14.6344 17.3576V14.3674C14.6344 13.6674 14.2709 13.0176 13.6744 12.6513L11.3729 11.2381C10.7264 10.8412 9.91177 10.8412 9.26534 11.2381L6.96383 12.6513C6.36729 13.0176 6.00377 13.6674 6.00377 14.3674V17.3576C6.00377 17.8343 6.39018 18.2207 6.86683 18.2207C7.34349 18.2207 7.7299 17.8343 7.7299 17.3576V14.3674C7.7299 14.2674 7.78183 14.1746 7.86705 14.1223L10.1686 12.7091Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeweb);
export default __webpack_public_path__ + "static/media/homeweb.5ea0def9f720cbb0749d6b5518681131.svg";
export { ForwardRef as ReactComponent };